export const EMIGRANT_RULES = {
    country: [
        {
            required: true,
            message: 'Ju lutem zgjidhni shtetin!',
        }
    ],
    city: [
        {
            required: true,
            message: 'Ju lutem plotësoni qytetin!',
        }
    ],
    name: [
        {
            required: true,
            message: "Ju lutem, plotësoni emrin!",
        },
    ],
    surname: [
        {
            required: true,
            message: "Ju lutem, plotësoni emrin!",
        },
    ],
    phone: [
        {
            required: true,
            message: "Ju lutem, plotësoni telefonin!",
        },
    ],
    referrer: [
        {
            required: false,
            message: "Ju lutem, plotësoni referuesin!",
        },
    ],
};